// =============================================================================
// Topbar — Sticky top header for operational apps
// =============================================================================

import clsx from "clsx";
import type { HTMLAttributes } from "react";

interface TopbarProps extends HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  className?: string;
  variant?: "default" | "brand";
}

export function Topbar({ children, className, variant = "default", ...props }: TopbarProps) {
  const isBrand = variant === "brand";
  return (
    <header
      style={
        isBrand
          ? { background: "var(--accent)", borderColor: "rgba(0,0,0,0.06)", top: 0, left: 0, right: 0, height: "var(--header-height)" }
          : { top: 0, left: 0, right: 0, height: "var(--header-height)" }
      }
      className={clsx(
        "fixed top-0 left-0 right-0 z-50 h-[var(--header-height)] shrink-0 flex items-center gap-4 transition-all duration-200",
        !isBrand && "bg-white border-b border-[var(--border-subtle)]",
        isBrand && "border-b text-white",
        className
      )}
      {...props}
    >
      {children}
    </header>
  );
}
